import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { AngularModalService } from './modal.service';
import { CompanyPageWorkflowStepWarningModalComponent } from 'src/app/pages/mission-control-page/company-page/company-page-workflow-step-warning-modal/company-page-workflow-step-warning-modal.component';

// Downgraded (see service.module.ajs.js) so the still-AngularJS
// company-page.component.js root controller (native port not due until
// build step 10) can open this native modal in place of its old
// `this.$uibModal.open({component: 'workflowStepWarningModal', ...})` call.
@Injectable({
  providedIn: 'root'
})
export class CompanyPageWorkflowStepWarningModalService {

  workflowStepWarningModal!: BsModalRef;

  constructor(private bsModalService: BsModalService, private angularModalService: AngularModalService) { }

  show(initialState: {
    companyId: any;
    clientOrBuId: any;
    context: string;
    stepName: string;
    message: string;
  }, onResult: (callbackObject: any) => void): void {
    const config = new ModalConfig();
    config.class = 'four-dot-five-modal-large';
    config.ignoreBackdropClick = true;
    config.initialState = initialState;
    this.workflowStepWarningModal = this.bsModalService.show(CompanyPageWorkflowStepWarningModalComponent, config);
    this.workflowStepWarningModal.content.onClose.subscribe((callbackObject: any) => {
      this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      onResult(callbackObject);
    });
  }
}
